export enum RightsInPcDialogType {
    Delete = 'delete',
    Disable = 'disable',
}
